
<div class="container-fluid" style="height:100vh;">
    <div class="flex-box-ui">
       <button type="button"  class="btn my-btn btn-success mx-2">Thank You</button>
       <!-- <button type="button"  class="btn my-btn btn-info mx-2" routerLink="/dashboard">Chartjs</button> -->
    </div>
</div>